import './style.css'
import * as THREE from 'three'
import {
    OrbitControls
} from 'three/examples/jsm/controls/OrbitControls.js'
import * as dat from 'lil-gui'
import {
    HemisphereLight,
    PointLightHelper
} from 'three'

/**
 * Base
 */
// Debug
const gui = new dat.GUI()
const parameters = {
    color: 0xffffff
}

const meshColor = gui.addFolder('အရောင်');
meshColor.addColor(parameters, 'color')
    .onChange(() => {
        material.color.set(parameters.color)
    }).name('ကုဗတုံး(အရောင်)');

meshColor.addColor(parameters, 'color')
    .onChange(() => {
        ambientLight.color.set(parameters.color)
    }).name('ဘေးပတ်လည်အလင်း(အရောင်)')

meshColor.addColor(parameters, 'color')
    .onChange(() => {
        directionalLight.color.set(parameters.color)
    }).name('တိုက်ရိုက်အလင်း(အရောင်)')

meshColor.addColor(parameters, 'color')
    .onChange(() => {
        pointLight.color.set(parameters.color)
    }).name('ပွိုင့် အလင်း (အရောင်)')


meshColor.addColor(parameters, 'color')
    .onChange(() => {
        rectAreaLight.color.set(parameters.color)
    }).name('အလင်းပျော့(အရောင်)')

meshColor.addColor(parameters, 'color')
    .onChange(() => {
        spotLight.color.set(parameters.color)
    }).name('ဆလိုက် (အရောင်)')




// Canvas
const canvas = document.querySelector('canvas.webgl')

// Scene
const scene = new THREE.Scene()

/**
 * Lights
 */
const ambientLight = new THREE.AmbientLight(0xffffff, 0);
scene.add(ambientLight);

const directionalLight = new THREE.DirectionalLight(0x00fffc, 0);
scene.add(directionalLight);

const hemisphereLight = new THREE.HemisphereLight(0xff0000, 0x0000ff, 0);
scene.add(hemisphereLight);
console.log(hemisphereLight);


const pointLight = new THREE.PointLight(0xff9000, 1, 10, 2);
pointLight.position.y = 0.9;
scene.add(pointLight);


const rectAreaLight = new THREE.RectAreaLight(0x4e00ff, 0, 1, 1)
scene.add(rectAreaLight);

const spotLight = new THREE.SpotLight(0x78ff00, 0, 10, Math.PI * 0.1, 0.25, 1);
spotLight.position.set(0, 2, 3);
scene.add(spotLight)






//Debug pannel
const lightIntensity = gui.addFolder('အလင်းပြင်းအား');
lightIntensity.add(ambientLight, 'intensity').min(0).max(1).step(0.01).name('ဘေးပတ်လည်အလင်း');
lightIntensity.add(directionalLight, 'intensity').min(0).max(1).step(0.01).name('တိုက်ရိုက်အလင်း');
lightIntensity.add(pointLight, 'intensity').min(0).max(2).step(0.01).name('ပွိုင့်အလင်း');
lightIntensity.add(hemisphereLight, 'intensity').min(0).max(2).step(0.01).name('မိုးကုပ်စက်ဝိုင်း');
lightIntensity.add(rectAreaLight, 'intensity').min(0).max(2).step(0.01).name('အလင်းဖျော့');
lightIntensity.add(spotLight, 'intensity').min(0).max(1).step(0.01).name('ဆလိုက်မီး');

const lightLocation = gui.addFolder('အလင်း တည်နေရာ')
lightLocation.add(pointLight.position, 'x').min(-3).max(5).step(0.01).name('ပွိုင့် ဘယ်/ညာ');
lightLocation.add(pointLight.position, 'y').min(-3).max(5).step(0.01).name('ပွိုင့် အပေါ်အောက်');
lightLocation.add(pointLight.position, 'z').min(-3).max(5).step(0.01).name('ပွိုင့် ရှေ့နောက်');
lightLocation.add(rectAreaLight.position, 'x').min(-3).max(3).step(0.01).name('အလင်းဖျော့ ဘယ်/ညာ');
lightLocation.add(rectAreaLight.position, 'z').min(-3).max(3).step(0.01).name('အလင်းဖျော့ ရှေ့/နောက်');
lightLocation.add(spotLight.position, 'x').min(-3).max(3).step(0.01).name('ဆလိုက်မီး ဘယ်/ညာ');
lightLocation.add(spotLight.position, 'z').min(-3).max(3).step(0.01).name('ဆလိုက်မီး ရှေ့/နောက်');




// const pointLight = new THREE.PointLight(0xffffff, 0.5)
// pointLight.position.x = 2
// pointLight.position.y = 3
// pointLight.position.z = 4
// scene.add(pointLight)


//Light Heplers
const pointLightHepler = new THREE.PointLightHelper(pointLight, 0.1)
scene.add(pointLightHepler);

/**
 * Objects
 */
// Material
const material = new THREE.MeshStandardMaterial()
material.roughness = 0.4

// Objects
const sphere = new THREE.Mesh(
    new THREE.SphereGeometry(0.5, 32, 32),
    material
)
sphere.position.x = -1.5

const cube = new THREE.Mesh(
    new THREE.BoxGeometry(0.75, 0.75, 0.75),
    material
)

const torus = new THREE.Mesh(
    new THREE.TorusGeometry(0.3, 0.2, 32, 64),
    material
)
torus.position.x = 1.5

const plane = new THREE.Mesh(
    new THREE.PlaneGeometry(5, 5),
    material
)
plane.rotation.x = -Math.PI * 0.5
plane.position.y = -0.65

scene.add(sphere, cube, torus, plane)
const SphereLocation = gui.addFolder('စက်ဝိုင်းတည်နေရာ')
SphereLocation.add(sphere.position, 'y').min(-3).max(3).step(0.01).name('စက်ဝိုင်းအပေါ်/အောက်');
SphereLocation.add(sphere.position, 'x').min(-3).max(3).step(0.01).name('စက်ဝိုင်းဘယ်/ညာ');
SphereLocation.add(sphere, 'visible').name("sphere");
SphereLocation.add(sphere.material, 'wireframe');
console.log(sphere.color);


/**
 * Sizes
 */
const sizes = {
    width: window.innerWidth,
    height: window.innerHeight
}

window.addEventListener('resize', () => {
    // Update sizes
    sizes.width = window.innerWidth
    sizes.height = window.innerHeight

    // Update camera
    camera.aspect = sizes.width / sizes.height
    camera.updateProjectionMatrix()

    // Update renderer
    renderer.setSize(sizes.width, sizes.height)
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
})

/**
 * Camera
 */
// Base camera
const camera = new THREE.PerspectiveCamera(75, sizes.width / sizes.height, 0.1, 100)
camera.position.x = 1
camera.position.y = 1
camera.position.z = 2
scene.add(camera)

// Controls
const controls = new OrbitControls(camera, canvas)
controls.enableDamping = true

/**
 * Renderer
 */
const renderer = new THREE.WebGLRenderer({
    canvas: canvas
})
renderer.setSize(sizes.width, sizes.height)
renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))

/**
 * Animate
 */
const clock = new THREE.Clock()

const tick = () => {
    const elapsedTime = clock.getElapsedTime()

    // Update objects
    sphere.rotation.y = 0.1 * elapsedTime
    cube.rotation.y = 0.1 * elapsedTime
    torus.rotation.y = 0.1 * elapsedTime

    sphere.rotation.x = 0.15 * elapsedTime
    cube.rotation.x = 0.15 * elapsedTime
    torus.rotation.x = 0.15 * elapsedTime

    // Update controls
    controls.update()

    // Render
    renderer.render(scene, camera)

    // Call tick again on the next frame
    window.requestAnimationFrame(tick)
}

tick()